import {
  Component,
} from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Row,
  Table,
} from "react-bootstrap";
import {
  withLocation,
} from "CommonCore/router-util";
import aenderungsmitteilungApi from "Apis/aenderungsmitteilung-api";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import Breadcrumb from "CommonComponents/breadcrumb";
import {
  Panel,
  Spinner,
} from "CommonComponents/bricks";
import {
  DetailView,
} from "CommonComponents/detail-view";

import {
  schema as personSchema,
} from "Apis/person-api";
import {
  schema as studienbereichSchema,
} from "Apis/person-studienbereich-api";
import {
  schema as werdegangSchema,
} from "Apis/person-werdegang-api";

import {
  AenderungsmitteilungErledigen,
} from "App/aenderungen-list-page";

import _ from "lodash";

@withLocation
@store("k_nutzerLookup")
@aenderungsmitteilungApi.current
@aenderungsmitteilungApi.actions
@uiconfig
export default class AenderungDetailPage extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const {
      currentAenderungsmitteilung: aem,
      k_nutzerLookup,
    } = this.props;

    const { erledigenPopup } = this.state;

    const bereiche = [{ key: "person", label: "Person", schema: personSchema },
                      { key: "studienbereich", label: "Studienbereich", schema: studienbereichSchema },
                      { key: "werdegang", label: "Werdegang", schema: werdegangSchema }];

    const nutzer = aem && k_nutzerLookup && k_nutzerLookup[aem.aem_nid];

    if (!nutzer || !aem) {
      return <Spinner />;
    }

    const makeBreadcrumb = key => {
      const items = [{ path: "/aenderungsmitteilung", name: "Änderungsmitteilungen" }];
      items.push({ name: `${ nutzer.n_vorname } ${ nutzer.n_name } vom ${ aem.aem_mitgeteiltam }`, path: `/aenderungsmitteilung/${ key }` });
      return <Breadcrumb data={items} />;
    };


    const aenderungen = aem.aem_daten;

    return <div className='detail-form'>


      {makeBreadcrumb(aem.aem_id)}

      <Panel>
        <ButtonToolbar className='align-right'>
          {!aem.aem_erledigtam && <Button onClick={this.startErledigen} className='float-end' variant='primary'>Erledigt</Button>}
        </ButtonToolbar>

        <Row><Col xs={6}>
          <DetailView
            entity={aem}
            injects={this.props}
            schema={aenderungsmitteilungApi.schema}
          />
        </Col></Row>

        <Panel bordered header={<h3>Geänderte Daten</h3>}>

          {erledigenPopup && <AenderungsmitteilungErledigen item={aem} onClose={this.closeErledigen} />}

          {_.map(bereiche, bereich => {
            if (_.isEmpty(aenderungen[bereich.key])) {
              return null;
            }

            return <span><h4>{bereich.label}</h4>
              <Table striped hover>
                <thead>
                  <tr>
                    <th>Feld</th>
                    <th>Aktuell</th>
                    <th>Änderung</th>
                  </tr>
                </thead>
                <tbody>

                  {_.map(Object.keys(aenderungen[bereich.key][0]), fld => {
                    const data = aenderungen[bereich.key][0][fld];
                    const def = bereich.schema.table.find(x => x.field == fld);
                    if (def) {
                      if (_.isObject(data)) {
                        // Object mit alt/neu
                        return <tr><td>{def.display}</td><td>{data.alt}</td> <td> {data.neu}</td></tr>;
                      }
                      return <tr><td>{def.display}</td><td colSpan={2}>{data}</td></tr>;
                    }
                  })}</tbody></Table></span>;
          })}
        </Panel>

      </Panel></div>;
  }

  startErledigen = () => {
    this.setState({ erledigenPopup: true });
  };
  closeErledigen = () => {
    this.setState({ erledigenPopup: false });
    this.props.retrieveAenderungsmitteilungList();
  };
}
